<script setup>
import { useFinanceStore } from '~/store/finance'
import { useAssetEye, useUnit } from '~/hooks/wallet'

defineProps({
  list: {
    type: Array,
    default: () => [],
  },
})
const { fixByEye } = useAssetEye()
const { unitList, unitType, dp } = useUnit()
const localePath = useLocalePath()
const finance = useFinanceStore()
finance.getAssets()
</script>

<template>
  <div class="flex flex-col gap-4 px-4 pt-1 pb-6 w-[300px]">
    <div class="flex flex-col rounded-lg">
      <CommonAssetEye>
        <div>
          {{ $t('总资产') }}
        </div>
      </CommonAssetEye>
      <div class="flex items-end mt-1">
        <span class="text-2xl font-bold">{{ fixByEye(fix(finance.getBanlanceByType({ type: 'total', unit: unitType }), dp)) }}</span>
        <n-popselect v-model:value="unitType" trigger="click" :options="unitList" placement="bottom-end" :show-checkmark="false">
          <button class="flex items-center py-1 !bg-transparent ms-2">
            <span class="uppercase">{{ unitType }}</span>
            <SvgoCommonIconChevronDown class="h-4 W-4 text-textPrimary" />
          </button>
        </n-popselect>
      </div>
    </div>
    <div class="flex font-medium">
      <NuxtLink :to="localePath('/assets/deposit')" class="flex flex-col items-center justify-center flex-1">
        <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.666992" width="40" height="40" rx="20" fill="var(--fillPageTertiary)" />
          <path d="M17.9873 19.6799L20.5473 22.2399L23.1073 19.6799" stroke="var(--functionalGreen3)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M20.5469 11.9998V22.1698" stroke="var(--functionalGreen3)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M28.667 20.1802C28.667 24.6002 25.667 28.1802 20.667 28.1802C15.667 28.1802 12.667 24.6002 12.667 20.1802" stroke="var(--textTextPrimary)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span class="mt-2 text-xs text-textPrimary">
          {{ $t('充值') }}
        </span>
      </NuxtLink>
      <NuxtLink :to="localePath('/assets/withdraw')" class="flex flex-col items-center justify-center flex-1">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="var(--fillPageTertiary)" />
          <path d="M22.6797 20.3201L20.1197 17.7601L17.5597 20.3201" stroke="var(--functionalGreen3)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M20.1201 28.0002V17.8302" stroke="var(--functionalGreen3)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 19.8198C12 15.3998 15 11.8198 20 11.8198C25 11.8198 28 15.3998 28 19.8198" stroke="var(--textTextPrimary)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <span class="mt-2 text-xs text-textPrimary">
          {{ $t('提现') }}
        </span>
      </NuxtLink>
      <NuxtLink :to="localePath('/assets/transfer')" class="flex flex-col items-center justify-center flex-1">
        <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.333984" width="40" height="40" rx="20" fill="var(--fillPageTertiary)" />
          <circle cx="20.334" cy="20" r="9" stroke="var(--textTextPrimary)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M16.7344 18.2001H23.9344L21.5344 16.4001" stroke="var(--functionalGreen3)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M23.9344 21.8003H16.7344L19.1344 23.6003" stroke="var(--textTextPrimary)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <span class="mt-2 text-xs text-textPrimary">
          {{ $t('划转') }}
        </span>
      </NuxtLink>
    </div>
  </div>
</template>
